import styled from "@emotion/styled";
import { Tags } from "../../components/Tags/Tags";

export const StyledDiv = styled.div`
  max-width: 64px;
`;

export const StyledElementContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  gap: 12px;
`;

export const StyledTag = styled(Tags)`
  white-space: nowrap;
  position: absolute;
  height: 14px;
  top: -5.5px;
  z-index: 5;
`;

export const StyledTypography = styled.span`
  color: #000;
  text-align: center;
  font-family: Rubik;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
`;
